import React, { useEffect } from "react";
import PageLayout from "../components/PageLayout";
import SearchHeader from "../components/SearchHeader";
import RegisterNew from "../components/register/RegisterNew";
import { useLoader } from "../context/LoaderContext";

const RegisterNewPage = () => {
  const { setLoading } = useLoader();
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [setLoading]);

  return (
    <PageLayout>
      <SearchHeader />
      <div className="inner-main-content">
        <RegisterNew />
      </div>
    </PageLayout>
  );
};

export default RegisterNewPage;
